import React, { useEffect } from 'react';
import ChoiceTable from '../Components/ChoiceTable';
import { Link } from "react-router-dom";
import { Container, Row, Col } from 'react-bootstrap';
import { aChoiceData, bChoiceData, cChoiceData, dChoiceData, choiceData } from '../Data/data.js'

const ChoiceTotal = (props) => {

  // Tilakoukku huolehtimaan focuksesta
  useEffect(() => {
    if(props.init === 'Total') {
      document.getElementById(props.focusId).focus()
    } 
    else {
      window.scrollTo(0, 0)
      props.setFocusId("Ahead")
      props.setInit('Total')
    }
  }, [props])

  return (
    <Container role="main" className="content" fluid>
      <Row className="">
        <Col sm={6} lg={3} className="">
          <ChoiceTable data={aChoiceData} className="wholeFitted" choice={props.all[0]} setChoice={props.sets[0]} popoverDirection={'right'} setFocusId={props.setFocusId} />
        </Col>
        <Col sm={6} lg={3} className="">
          <ChoiceTable data={bChoiceData} className="wholeFitted" choice={props.all[1]} setChoice={props.sets[1]} popoverDirection={'right'} setFocusId={props.setFocusId} />
        </Col>
        <Col sm={6} lg={3} className="">
          <ChoiceTable data={cChoiceData} className="wholeFitted" choice={props.all[2]} setChoice={props.sets[2]} popoverDirection={'right'} setFocusId={props.setFocusId} />
        </Col>
        <Col sm={6} lg={3} className="">
          <ChoiceTable data={dChoiceData} className="wholeFitted" choice={props.all[3]} setChoice={props.sets[3]} popoverDirection={'left'} setFocusId={props.setFocusId} />
        </Col>
      </Row>
      <Row className="">
        <Col className="text-center p-3">
          <Link to={choiceData.links.next} title="Vahvista valinnat ja siirry eteenpäin" all={props.all} className="adjustBtn2 btn mainButton w-25">{choiceData.buttons.confirmAll}</Link>
        </Col>
      </Row>
    </Container>
  );
};

export default ChoiceTotal;